module.exports = __webpack_public_path__ + "media/site_templates/www.airconditionerrepair.net.au/images/our_services_2-5dce2fae0e59aa75549e2d9326c7224b.jpg";